import { render, staticRenderFns } from "./StockMovement.vue?vue&type=template&id=7ccafb96&scoped=true"
import script from "./StockMovement.vue?vue&type=script&lang=js"
export * from "./StockMovement.vue?vue&type=script&lang=js"
import style0 from "./StockMovement.vue?vue&type=style&index=0&id=7ccafb96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccafb96",
  null
  
)

export default component.exports